export default __webpack_public_path__ + "static/media/dashboard_active.dd505520.svg";